<template>
  <div class="sales-contract-print">
    <div style="width: 210mm; margin: 2mm auto">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <table id="print" class="print-table">
      <thead>
        <tr>
          <td>
            <!-- 这里给页眉占位 -->
            <header class="print-header">
              <img class="company-logo" :src="$tenant.stepIcon">
              <div class="company-standad">GK202506</div>
            </header>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="print-area">
              <div class="printItem">
                <div class="title">产品销售合同</div>
                <section class="contract-info">
                  <div class="flex-justify">
                    <div class="flex-left">
                      合同编号：<span class="display-value">{{contract.clientContractNo}}</span><input v-model="contract.clientContractNo" placeholder="请输入" class="editable-input">
                    </div>
                    <div class="flex-right">签约地：杭州余杭区</div>
                  </div>
                  <div class="font-bold">
                    甲方：
                    <span class="display-value">{{contract.customerName}}</span><input v-model="contract.customerName" placeholder="请输入" class="editable-input" style="width: 250px;">
                  </div>
                  <div class="font-bold">
                    乙方：
                    <span class="display-value">{{contract.belongToCustomerNo}}</span><input v-model="contract.belongToCustomerNo" placeholder="请输入" class="editable-input" style="width: 250px;">
                  </div>
                  <div class="font-bold section-title">一、产品名称、规格、数量：</div>
                </section>
                <!-- 合同明细 -->
                <table class="contract-item">
                  <thead>
                    <tr>
                      <td width="50">序号</td>
                      <td width="100">产品名称</td>
                      <td width="100">型号规格</td>
                      <td width="100">单位</td>
                      <td width="60">数量</td>
                      <td width="100">含税单价（元）</td>
                      <td width="100">含税金额（元）</td>
                      <td width="100">备注</td>
                    </tr>
                  </thead>
                  <tr v-for="(item, index) in contract.materialList" :key="item.id">
                    <td>{{index+1}}</td>
                    <td>
                      <span class="display-value">{{item.sapProductName}}</span>
                      <input v-model="item.sapProductName" placeholder="请输入" class="table-input editable-input">
                    </td>
                    <td>
                      <span class="display-value">{{item.manufacturerModel}}</span>
                      <input v-model="item.manufacturerModel" placeholder="请输入" class="table-input editable-input">
                    </td>
                    <td>
                      <span class="display-value">{{item.unit}}</span>
                      <input v-model="item.unit" placeholder="请输入" class="table-input editable-input">
                    </td>
                    <td>
                      <span class="display-value">{{item.quantity}}</span>
                      <input
                          v-model="item.quantity"
                          placeholder="请输入"
                          type="number"
                          class="table-input editable-input"
                          @input="calculateItemTotal(index)">
                    </td>
                    <td>
                      <span class="display-value">{{item.unitPrice}}</span>
                      <input
                          v-model="item.unitPrice"
                          placeholder="请输入"
                          type="number"
                          class="table-input editable-input"
                          @input="calculateItemTotal(index)">
                    </td>
                    <td class="text-right">{{getItemTotal(item)}}</td>
                    <td>
                      <span class="display-value">{{item.note}}</span>
                      <input v-model="item.note" placeholder="请输入" class="table-input editable-input">
                    </td>
                  </tr>
                  <tfoot>
                    <tr>
                      <td colspan="6" style="text-align: right;">合计：</td>
                      <td>￥{{contractItemsTotalPrice}}</td>
                      <td/>
                    </tr>
                    <tr>
                      <td colspan="2">总金额：（大写）</td>
                      <td colspan="6" style="text-align: left;">{{contractItemsTotalPriceUpper}}</td>
                    </tr>
                  </tfoot>
                </table>

                <section class="contract-info">
                  <div class="font-bold section-title">二、交货方式（二选一）</div>
                  <div>1. <el-checkbox/> 甲方自提</div>
                  <div>2. <el-checkbox :checked="true"/> 乙方送达  <span style="margin-left: 20px;">交货地址：</span><span class="display-value">{{contract.customerAddress}}</span><input v-model="contract.customerAddress" style="width: 400px;" placeholder="请输入" class="delivery-address-input editable-input"></div>
                  <div>交货联系人姓名：<span class="display-value">{{contract.customerContact}}</span><input v-model="contract.customerContact" placeholder="请输入" class="contact-name-input editable-input">联系电话：<span class="display-value">{{contract.customerPhone}}</span><input v-model="contract.customerPhone" placeholder="请输入" class="editable-input"></div>
                  <div>若甲方指定人员不在收货现场，甲方其他工作人员的签字也同等有效。</div>

                  <div class="font-bold section-title">三、运费及包装：</div>
                  <div>1.	交货方式为乙方送达时运费由乙方承担。</div>
                  <div>2.	包装方式：纸箱</div>
                  <div class="font-bold section-title">四、验收</div>
                  <div>1.按乙方出厂标准执行，甲方应当对每批货物完好性进行及时检查和验收。货物在到达甲方指定地点7个工作日内，如甲方未书面向乙方报告货物受损或故障，视为每批货物已验收合格且被甲方接受。</div>
                  <div>2.如有其它约定，其他验收相关事宜参见书面签署的相关约定要求。</div>
                  <div class="font-bold section-title">五、结算方式：<span class="display-value">{{contract.paymentDays}}</span> <input v-model="contract.paymentDays" placeholder="请输入" class="contract-input"></div>
                  <div><span class="font-bold">六、合同变更：</span>本合同签订后，如甲方提出更改设计资料或停止生产，乙方在减少报废的前提下，尽量满足要求，并相应顺延交期。同时甲方需承担材料损失以及完成生产的成品价值。</div>
                  <div><span class="font-bold">七、反商业贿赂：</span>双方承诺，严格遵守中华人民共和国《反不正当竞争法》等禁止商业贿赂行为的相关规定，在订立及履行合同过程中，不向对方及其工作人员、相关第三方及其工作人员行商业贿赂，具体包括任何形式的礼金礼品、有价证券、购物券、回扣、佣金、咨询费、劳务费、赞助费、宣传费，以及支付旅游费用、报销各种消费凭证等。若经守约方查证违约方存在商业贿赂行为的，守约方有权解除本合同，并要求违约方支付10万元或本合同金额的10倍（二者取较高者）作为违约金。</div>
                  <div class="font-bold section-title">八、保密：</div>
                  <div>1.本合同成交价格需要保密。</div>
                  <div>2.双方不得丢失、复制及向任何第三者透露从对方得到的任何技术文件和专有文件（包括所有的修改和改进资料）。</div>
                  <div>3.如有人需要借用、参阅或复制对方的技术资料，必须经另外一方书面同意。</div>
                  <div>4.双方应对本合同履行获知的有关对方的技术信息、经营信息等商业秘密保密，不透露给第三方。保密义务在本合同终止或解除之后继续有效。</div>
                  <div><span class="font-bold">九、责任限制：</span>除非乙方有重大过失或故意行为，在其它任何情况下，乙方与合同相关的全部责任不应超过合同价。在乙方应甲方要求提供技术服务过程中，由于甲方或任何第三方提供或使用不适当的设备或者操作不当而引起的损坏，甲乙双方应协商解决。在任何情况下，乙方对于一切特殊的，间接的或继发性的损失概不负责。诸如，但不仅限于，因货物的使用或操作引起的任何经济损失，利润损失，收入损失，使用损失，生产损失，业务损失，资本费用或因甲方或第三方的使用或操作引起的运作中断所导致的费用等。</div>
                  <div><span class="font-bold">十、不可抗力：</span>遇不可抗力因素造成乙方未能按期交货，乙方应及时通知甲方协商解决。</div>
                  <div><span class="font-bold">十一、质保期：</span><span class="display-value">{{contract.warrantyPeriod}}</span><input v-model="contract.warrantyPeriod" placeholder="请输入" class="contract-input editable-input">个月，自甲方确认收货之日起算。</div>
                  <div class="font-bold section-title">十二、违约责任</div>
                  <div>1.甲方逾期支付货款的，应当以未付货值为基数按照日万分之五的标准向乙方支付逾期付款违约金。</div>
                  <div>2.甲方逾期清偿部分或全部欠款（包括本协议签订前的原有欠款）时，乙方有权终止执行本协议，并要求甲方立即清偿全部到期及未到期的欠款本金、利息，违约金、损害赔偿金、实现债权而发生的费用（包括律师费、差旅费、诉讼费、仲裁费、执行费、评估费、诉讼财产保全费及其责任保险费、拍卖或变卖费等）和其他应付乙方的一切费用。</div>
                  <div>3.本合同签订后，任何一方不得随意解除或终止。乙方逾期交货或因产品质量问题造成甲方损失的，乙方应赔偿甲方的直接损失；甲方违反本合同的约定，造成乙方损失的，甲方承担相应的违约责任及直接损害赔偿责任。</div>
                  <div class="font-bold section-title">十三、合同的有效与终止</div>
                  <div>本合同的有效期应自本合同生效日起至本合同指明的保证期满及甲方按本合同支付完所有应付款项后方告结束。基于以下事件的发生，任何一方可以立即终止合同：（1）违约方严重违反合同，并且未在收到违约通知后的90天或双方约定的任何期限内加以纠正；（2）违约方破产或资不抵债。</div>
                  <div class="font-bold section-title">十四、合同关联性</div>
                  <div>若甲乙双方多次签署本项产品的销售合同时，前一合同的逾期欠款未付清之前，乙方有权将后一合同的款项优先冲抵前一合同欠款。</div>
                  <div class="font-bold section-title">十五、争议解决</div>
                  <div>若双方因本合同产生纠纷，应友好协商；协商不成可以向合同签订地人民法院提起诉讼。</div>
                  <div class="font-bold section-title">十六、出口管制</div>
                  <div>1.	甲乙双方应严格遵守安理会决议和各相关国家适用的出口管制和制裁法规，甲方保证不得将乙方产品、产品零部件、备件等直接或间接的销往禁止交易国家或禁止交易国家的终端客户（包括但不限于伊朗、叙利亚、古巴和朝鲜等相关被制裁国家）。</div>
                  <div>2.	甲方承诺从乙方处采购的货物以及利用该货物直接生产的产品只限于民用，不会直接或间接以任何方式用于制造生物、化学武器或该种武器的初级化学材料，并且不会直接或间接以任何方式最终用于核用途。</div>
                  <div>3.	以上承诺/保证甲方如有违反，产生的的损失、索赔等法律责任由甲方自行承担。如造成乙方损失，由甲方承担相应赔偿责任。</div>
                  <div class="font-bold section-title">十七、其他</div>
                  <div>1.	在本协议履行及相关业务合作过程中涉及货款、价格、质量等实质性内容或违约金、赔偿金等涉及乙方经济利益、义务负担的，需乙方确认的文件或/和协议，由乙方加盖公章后生效，否则对乙方不具有约束力。乙方任何部门或个人出具的任何处理意见或允诺，对乙方不具有约束力。</div>
                  <div>2.甲乙双方确认授权以下联系人及联系方式沟通本合同有关事宜，包括发送采购订单、确认收货、发票开具、核对账目等：</div>
                  <div>
                    甲方联系人：
                    <span class="display-value">{{contract.customerContact}}</span>
                    <input v-model="contract.customerContact" placeholder="请输入" class="editable-input">
                    ，联系方式（包括电话、邮箱、微信等）：
                    <span class="display-value">{{contract.customerPhone}}</span> 
                    <input v-model="contract.customerPhone" placeholder="请输入" class="editable-input">
                  </div>
                  <div>
                    乙方联系人：
                    <span class="display-value">{{contract.salesPersonName}}</span><input v-model="contract.salesPersonName" placeholder="请输入" class="editable-input">
                    ，联系方式（包括电话、邮箱、微信等）：
                    <span class="display-value">{{contract.salesPersonPhone}}</span><input v-model="contract.salesPersonPhone" placeholder="请输入" class="editable-input">
                  </div>
                  <div>3.本合同自双方盖章后生效,一式贰份，双方各执壹份。</div>
                  <div>
                    4.甲乙双方同意选择第 (1)
                    <!--                    <span class="display-value">'(1)'</span>-->
                    <!--                    <input v-model="contract.salesPersonPhone" placeholder="请输入" class="editable-input">-->
                    种方式用印
                  </div>
                  <div>（1）物理用印</div>
                  <div>本合同自双方加盖物理公章或合同章后生效。</div>
                  <div>（2）电子用印</div>
                  <div>甲乙双方协商一致本协议可以以电子文件的方式签署，双方确认签署前已对本合同内容知晓并认可，双方采用电子用印的：签署方式为一方先行以电子签名的形式签章，随后将已签章的PDF格式的合同电子文件发给另一方，另一方电子签章后本合同生效。后签章方应将双方电子签章后的电子文件发送至对方，该电子文件即为本合同的原件。一方使用电子用印一方使用物理用印的，由一方先行电子签章，随后将已签章的PDF格式的合同电子文件发给另一方，另一方打印后物理用印，后签章方应将双方签章后的纸质合同发送至对方，该纸质合同即为本合同的原件。</div>
                  <div style="margin-top: 20px;">（以下为签署页，无正文）</div>
                  <section class="signatures">
                    <div class="sign-item font-bold">
                      <div class="sign-label">
                        甲方：
                        <span class="display-value">{{contract.customerName}}</span>
                        <input v-model="contract.customerName" placeholder="请输入" class="editable-input" style="width: 220px;">
                      </div>
                      <div class="sign-line">代表签字：</div>
                      <div class="sign-date">签署日期：</div>
                    </div>
                    <div class="sign-item font-bold">
                      <div class="sign-label">乙方：新时达工控技术（杭州）有限公司 </div>
                      <div class="sign-line">代表签字：</div>
                      <div class="sign-date">签署日期：</div>
                    </div>
                  </section>
                </section>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import toChineseRMB from "@/util/toChineseRMB.js";
  export default {
    name: "SalesContractPrint",
    data() {
      return {
        contract: {
          contractNo: "",
          clientContractNo: "",
          customerName: "",
          belongToCustomerNo: "",
          deliveryMessage: "",
          sendPeopleName: "",
          customerNo: "",
          warrantyPeriod: "",
          paymentDays: "",
          customerContact: "",
          customerPhone: "",
          salesPersonName: "",
          salesPersonPhone: "",
          materialList: [
            // 示例数据，包含可编辑字段
            {
              id: 1,
              specification: "",
              manufacturerModel: "",
              unit: "",
              quantity: "",
              unitPrice: "",
              note: "",
            },
          ],
        },
      };
    },
    computed: {
      // 合同明细总价
      contractItemsTotalPrice() {
        const materialList = (this.contract && Array.isArray(this.contract.materialList)) ? this.contract.materialList : [];
        const total = materialList.reduce((sum, item) => {
          const quantity = parseFloat(item.quantity) || 0;
          const unitPrice = parseFloat(item.unitPrice) || 0;
          return sum + (quantity * unitPrice);
        }, 0);
        const valid = Number.isFinite(total) ? total : 0;
        return valid.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      // 合同明细总价大写
      contractItemsTotalPriceUpper() {
        const materialList = (this.contract && Array.isArray(this.contract.materialList)) ? this.contract.materialList : [];
        const total = materialList.reduce((sum, item) => {
          const quantity = parseFloat(item.quantity) || 0;
          const unitPrice = parseFloat(item.unitPrice) || 0;
          return sum + (quantity * unitPrice);
        }, 0);
        return toChineseRMB(total);
      },
    },
    mounted() {
      // 如通过 URL 传入 ids，可在此处读取并请求后端数据
      const id = this.$route && this.$route.query && this.$route.query.id;
      if (id) {
        this.fetchData(id);
      }
    },
    methods: {
      fetchData(id) {
        // 示例：根据后端接口调整
        this.$http.get("basic", `clientContracts/${id}`).then((res) => {
          if (res && res.success) {
            Object.assign(this.contract, res.data || {});
          }
        }).catch(() => {});
      },
      // 计算单项总价
      getItemTotal(item) {
        const quantity = parseFloat(item.quantity) || 0;
        const unitPrice = parseFloat(item.unitPrice) || 0;
        return (quantity * unitPrice).toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      // 输入时重新计算
      calculateItemTotal() {
        // Vue会自动重新计算computed属性
        this.$forceUpdate();
      },
      printHandle() {
        window.print();
      },
    },
  };
</script>

<style lang="scss" scoped>
.print-table {
  width: 210mm;
  margin: 0 auto;
  border-collapse: collapse;
  border: 1px solid #000;
  font-family: 'SimSun', '宋体', serif;
  font-size: 11pt;
  line-height:1.4;
  color: #000;
  background-color: #f0f0f0;
}
.print-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  /* 屏幕展示保持相对布局（非打印时） */
  line-height: 1.8cm;
  padding: 1.5cm 2cm 0;
}
.company-logo { width: 80px; }
.company-standad{
  color: #999;
  font-size: 10pt;
  font-weight: 500;
}
.printItem {
  padding: 0 2cm 1.5cm;
  table {
    width: 100%; 
    border: 1px solid #333;
    border-collapse: collapse; 
    margin-bottom: 20px;
    text-align: center;
    thead{
      font-weight: bold;
    }
    tr {
      td {
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        padding: 5px;
      }
    }
  }

  
  .flex-justify{
    display: flex;
    justify-content: space-between;
  }
  .font-bold{
    font-weight: bold;
  }

  .title { font-size: 20px; font-weight: bold; text-align: center; margin-bottom: 10px;}
  .contract-info{
    ::v-deep .el-checkbox__label{
      font-size: 10pt;
    }
    ::v-deep .el-checkbox{
      .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color: white;
        border-color: #000;
      }
      .el-checkbox__inner::after{
        border-color: #000;
      }
      .el-checkbox__inner{
        border-color: #000;
      }
    }
  }
  .contract-item{
    margin-bottom: 20px;
    thead {
      /* 确保表头在打印多页时重复 */
      display: table-header-group;
    }
  }
  .agreement-content .section-title { font-weight: bold; }
  .agreement-content .section-body { min-height: 200px; border: 1px solid #eee; padding: 10px; }
  .signatures { display: flex; justify-content: space-between; margin-top: 0px; }
  .sign-item { width: 45%; }
  .sign-label { margin-bottom: 20px; }
  .sign-line { margin-bottom: 10px; }
}
.editable-input {
  border: none;
  border-bottom: 2px solid #000;
  background: transparent;
  padding: 2px 4px;
  outline: none;
  color: #000;
  width: auto;
  min-width: 120px;
  transition: border-color 0.2s ease;
}

.editable-input:focus {
  border-bottom-color: #409EFF;
}

/* 确保输入框与文本对齐 */
.editable-input {
  vertical-align: baseline;
}

/* 特定输入框的宽度设置 */
.delivery-address-input {
  min-width: 200px;
}

.contact-name-input {
  margin-right: 20px;
}

/* 表格输入框专用样式 */
.table-input {
  width: 100%;
  min-width: 80px;
  border: none;
  border-bottom: 1px solid #333;
  background: transparent;
  padding: 1px 2px;
  outline: none;
  text-align: center;
  font-size: inherit;
  font-family: inherit;
}

.table-input:focus {
  border-bottom-color: #409EFF;
}


/* 文本右对齐的单元格 */
.text-right {
  text-align: right;
  vertical-align: middle;
}

.contract-input {
    border: none;
    border-bottom: 2px solid #333;
    background: transparent;
    outline: none;
    padding: 2px;
    min-width: 120px;
    font-family: inherit;
    font-size: inherit;
  }
  /* 隐藏显示标签 */
  .display-value {
    display: none;
  }
/* 打印专用规则 */
@media print {
  .print-table{
    font-size: 11pt;
  }
  .title{
    font-size: 16pt;
  }
  .company-standad{
    font-size: 10pt;
  }
  .printBtn {
    display: none;
  }
  .signatures{
    page-break-inside: avoid;
  }
  
  /* 隐藏显示标签 */
  .display-value {
    display: initial!important;
  }
  
  /* 通用输入框打印样式 - 优化宽度自适应 */
  .editable-input, .contract-input, .table-input {
      display: none!important;
  }
  
  .print-header{
    padding: 0;
  }
  
  /* 设置页面样式 */
  .print-area, .printItem {
    border: none;
    padding: 0 1px;
  }

  .print-table{
    border:none;
    background-color: #fff;
  }
  
  /* 实现打印页码功能 */
  @page {
    margin: 0.5cm 1.5cm 1.5cm; /* 底部边距要足够大以容纳页脚 */
    counter-increment: page;
    @bottom-center{
      font-size: 10pt;
      color: #000;
      content: "第 " counter(page) " 页 共 " counter(pages) " 页";
    }
  }
}
</style>
